import {
  Button,
  Form,
  Field,
  NavBar,
  DropdownMenu,
  DropdownItem,
  Search,
  Cell,
  CellGroup,
  Tag,
  Toast,
  Tabbar,
  TabbarItem,
  Calendar,
  List,
  Row,
  Col,
  Tab,
  Tabs,
  Popup,
  Picker,
  Uploader,
  Dialog,
  Icon,
  DatetimePicker,
  Divider,
  Checkbox,
  Pagination,
  CheckboxGroup,
  RadioGroup, 
  Radio,
  NoticeBar,
  Stepper, 
  Switch,
  ActionSheet,
  Collapse, 
  CollapseItem,
  Cascader,
  Overlay,
  Empty
} from 'vant'

export const vantComponent = [
  Button,
  Form,
  Field,
  NavBar,
  DropdownMenu,
  DropdownItem,
  Search,
  Cell,
  CellGroup,
  Tag,
  Toast,
  Tabbar,
  TabbarItem,
  Calendar,
  List,
  Row,
  Col,
  Tab,
  Tabs,
  Popup,
  Picker,
  Uploader,
  Dialog,
  Icon,
  DatetimePicker,
  Divider,
  Checkbox,
  Pagination,
  CheckboxGroup,
  RadioGroup, 
  Radio,
  NoticeBar,
  Stepper,
  Switch,
  ActionSheet,
  Collapse, 
  CollapseItem,
  Cascader,
  Overlay,
  Empty
]
